import { Box, InputCheckBox } from "@itandi/itandi-bb-ui";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import type { DealSearchCondition, SearchApplicationType } from "~/models/Deal";

type Props = {
	applicationType: SearchApplicationType;
	dealSearchCondition: DealSearchCondition;
	label: string;
};

export const ApplicationTypeCheckBox: React.FC<Props> = ({
	applicationType,
	label,
	dealSearchCondition
}: Props) => {
	const { setValue, getValues } = useFormContext<DealSearchCondition>();
	const { applicationTypes: applicationTypesFromParam } = dealSearchCondition;
	const defaultCheck = (): boolean => {
		if (applicationTypesFromParam) {
			return applicationTypesFromParam.includes(applicationType);
		}
		return false;
	};

	const [checked, setChecked] = useState<boolean>(defaultCheck);
	const onChangeApplicationType = React.useCallback((): void => {
		const applicationTypes = getValues("applicationTypes") || [];
		if (!checked) {
			// 追加
			if (!applicationTypes.includes(applicationType)) {
				applicationTypes.push(applicationType);
			}
		} else {
			// 削除
			applicationTypes.splice(applicationTypes.indexOf(applicationType), 1);
		}
		setValue("applicationTypes", applicationTypes);
		setChecked(!checked);
	}, [checked, applicationType, getValues, setValue]);
	return (
		<Box margin={4} minWidth={0}>
			<InputCheckBox
				checked={checked}
				label={label}
				onChange={onChangeApplicationType}
			/>
		</Box>
	);
};
